import { DirectoryTagsPanel } from '../components/DirectoryTagsPanel';

/**
 * The vocabularies behind the garages and suppliers directories (gitaumoses4/chukua#173). A garage or supplier form
 * can also add an entry as it is typed; this is where an admin renames or retires one.
 */
export function DirectoryTagsPage() {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <DirectoryTagsPanel kind="service_type" title="Garage service types" description="What a garage can be sent: tyres, welding, engine overhaul." />
      <DirectoryTagsPanel kind="supplier_category" title="Supplier categories" description="What a parts supplier stocks: filters, brakes, tyres." />
    </div>
  );
}
